/**
 * Alfabeto de 1024 emojis para o codec base-1024.
 *
 * Criterios, verificados por teste a cada execucao do CI:
 *   - exatamente 1024 simbolos = 10 bits por emoji
 *   - um unico ponto de codigo cada (2 unidades UTF-16), nunca sequencias
 *     ZWJ nem modificadores de tom de pele: sequencias quebram ao passar
 *     por normalizacao de teclado e por alguns clientes
 *   - todos com Emoji_Presentation: renderizam coloridos sem VS16
 *   - faixas do Unicode 6.0 a 14.0 (2010-2021): em 2026, suporte universal
 *
 * ARQUIVO GERADO — nao editar a mao. Mudar um simbolo quebra a decodificacao
 * de toda mensagem ja enviada.
 */

export const EMOJI_ALPHABET: readonly string[] = [
  '🌀',
  '🌁',
  '🌂',
  '🌃',
  '🌄',
  '🌅',
  '🌆',
  '🌇',
  '🌈',
  '🌉',
  '🌊',
  '🌋',
  '🌌',
  '🌍',
  '🌎',
  '🌏',
  '🌐',
  '🌑',
  '🌒',
  '🌓',
  '🌔',
  '🌕',
  '🌖',
  '🌗',
  '🌘',
  '🌙',
  '🌚',
  '🌛',
  '🌜',
  '🌝',
  '🌞',
  '🌟',
  '🌠',
  '🌭',
  '🌮',
  '🌯',
  '🌰',
  '🌱',
  '🌲',
  '🌳',
  '🌴',
  '🌵',
  '🌷',
  '🌸',
  '🌹',
  '🌺',
  '🌻',
  '🌼',
  '🌽',
  '🌾',
  '🌿',
  '🍀',
  '🍁',
  '🍂',
  '🍃',
  '🍄',
  '🍅',
  '🍆',
  '🍇',
  '🍈',
  '🍉',
  '🍊',
  '🍋',
  '🍌',
  '🍍',
  '🍎',
  '🍏',
  '🍐',
  '🍑',
  '🍒',
  '🍓',
  '🍔',
  '🍕',
  '🍖',
  '🍗',
  '🍘',
  '🍙',
  '🍚',
  '🍛',
  '🍜',
  '🍝',
  '🍞',
  '🍟',
  '🍠',
  '🍡',
  '🍢',
  '🍣',
  '🍤',
  '🍥',
  '🍦',
  '🍧',
  '🍨',
  '🍩',
  '🍪',
  '🍫',
  '🍬',
  '🍭',
  '🍮',
  '🍯',
  '🍰',
  '🍱',
  '🍲',
  '🍳',
  '🍴',
  '🍵',
  '🍶',
  '🍷',
  '🍸',
  '🍹',
  '🍺',
  '🍻',
  '🍼',
  '🍾',
  '🍿',
  '🎀',
  '🎁',
  '🎂',
  '🎃',
  '🎄',
  '🎅',
  '🎆',
  '🎇',
  '🎈',
  '🎉',
  '🎊',
  '🎋',
  '🎌',
  '🎍',
  '🎎',
  '🎏',
  '🎐',
  '🎑',
  '🎒',
  '🎓',
  '🎠',
  '🎡',
  '🎢',
  '🎣',
  '🎤',
  '🎥',
  '🎦',
  '🎧',
  '🎨',
  '🎩',
  '🎪',
  '🎫',
  '🎬',
  '🎭',
  '🎮',
  '🎯',
  '🎰',
  '🎱',
  '🎲',
  '🎳',
  '🎴',
  '🎵',
  '🎶',
  '🎷',
  '🎸',
  '🎹',
  '🎺',
  '🎻',
  '🎼',
  '🎽',
  '🎾',
  '🎿',
  '🏀',
  '🏁',
  '🏂',
  '🏃',
  '🏄',
  '🏅',
  '🏆',
  '🏇',
  '🏈',
  '🏉',
  '🏊',
  '🏏',
  '🏐',
  '🏑',
  '🏒',
  '🏓',
  '🏠',
  '🏡',
  '🏢',
  '🏣',
  '🏤',
  '🏥',
  '🏦',
  '🏧',
  '🏨',
  '🏩',
  '🏪',
  '🏫',
  '🏬',
  '🏭',
  '🏮',
  '🏯',
  '🏰',
  '🏴',
  '🏸',
  '🏹',
  '🏺',
  '🐀',
  '🐁',
  '🐂',
  '🐃',
  '🐄',
  '🐅',
  '🐆',
  '🐇',
  '🐈',
  '🐉',
  '🐊',
  '🐋',
  '🐌',
  '🐍',
  '🐎',
  '🐏',
  '🐐',
  '🐑',
  '🐒',
  '🐓',
  '🐔',
  '🐕',
  '🐖',
  '🐗',
  '🐘',
  '🐙',
  '🐚',
  '🐛',
  '🐜',
  '🐝',
  '🐞',
  '🐟',
  '🐠',
  '🐡',
  '🐢',
  '🐣',
  '🐤',
  '🐥',
  '🐦',
  '🐧',
  '🐨',
  '🐩',
  '🐪',
  '🐫',
  '🐬',
  '🐭',
  '🐮',
  '🐯',
  '🐰',
  '🐱',
  '🐲',
  '🐳',
  '🐴',
  '🐵',
  '🐶',
  '🐷',
  '🐸',
  '🐹',
  '🐺',
  '🐻',
  '🐼',
  '🐽',
  '🐾',
  '👀',
  '👂',
  '👃',
  '👄',
  '👅',
  '👆',
  '👇',
  '👈',
  '👉',
  '👊',
  '👋',
  '👌',
  '👍',
  '👎',
  '👏',
  '👐',
  '👑',
  '👒',
  '👓',
  '👔',
  '👕',
  '👖',
  '👗',
  '👘',
  '👙',
  '👚',
  '👛',
  '👜',
  '👝',
  '👞',
  '👟',
  '👠',
  '👡',
  '👢',
  '👣',
  '👤',
  '👥',
  '👦',
  '👧',
  '👨',
  '👩',
  '👪',
  '👫',
  '👬',
  '👭',
  '👮',
  '👯',
  '👰',
  '👱',
  '👲',
  '👳',
  '👴',
  '👵',
  '👶',
  '👷',
  '👸',
  '👹',
  '👺',
  '👻',
  '👼',
  '👽',
  '👾',
  '👿',
  '💀',
  '💁',
  '💂',
  '💃',
  '💄',
  '💅',
  '💆',
  '💇',
  '💈',
  '💉',
  '💊',
  '💋',
  '💌',
  '💍',
  '💎',
  '💏',
  '💐',
  '💑',
  '💒',
  '💓',
  '💔',
  '💕',
  '💖',
  '💗',
  '💘',
  '💙',
  '💚',
  '💛',
  '💜',
  '💝',
  '💞',
  '💟',
  '💠',
  '💡',
  '💢',
  '💣',
  '💤',
  '💥',
  '💦',
  '💧',
  '💨',
  '💩',
  '💪',
  '💫',
  '💬',
  '💭',
  '💮',
  '💯',
  '💰',
  '💱',
  '💲',
  '💳',
  '💴',
  '💵',
  '💶',
  '💷',
  '💸',
  '💹',
  '💺',
  '💻',
  '💼',
  '💽',
  '💾',
  '💿',
  '📀',
  '📁',
  '📂',
  '📃',
  '📄',
  '📅',
  '📆',
  '📇',
  '📈',
  '📉',
  '📊',
  '📋',
  '📌',
  '📍',
  '📎',
  '📏',
  '📐',
  '📑',
  '📒',
  '📓',
  '📔',
  '📕',
  '📖',
  '📗',
  '📘',
  '📙',
  '📚',
  '📛',
  '📜',
  '📝',
  '📞',
  '📟',
  '📠',
  '📡',
  '📢',
  '📣',
  '📤',
  '📥',
  '📦',
  '📧',
  '📨',
  '📩',
  '📪',
  '📫',
  '📬',
  '📭',
  '📮',
  '📯',
  '📰',
  '📱',
  '📲',
  '📳',
  '📴',
  '📵',
  '📶',
  '📷',
  '📸',
  '📹',
  '📺',
  '📻',
  '📼',
  '📿',
  '🔀',
  '🔁',
  '🔂',
  '🔃',
  '🔄',
  '🔅',
  '🔆',
  '🔇',
  '🔈',
  '🔉',
  '🔊',
  '🔋',
  '🔌',
  '🔍',
  '🔎',
  '🔏',
  '🔐',
  '🔑',
  '🔒',
  '🔓',
  '🔔',
  '🔕',
  '🔖',
  '🔗',
  '🔘',
  '🔙',
  '🔚',
  '🔛',
  '🔜',
  '🔝',
  '🔞',
  '🔟',
  '🔠',
  '🔡',
  '🔢',
  '🔣',
  '🔤',
  '🔥',
  '🔦',
  '🔧',
  '🔨',
  '🔩',
  '🔪',
  '🔫',
  '🔬',
  '🔭',
  '🔮',
  '🔯',
  '🔰',
  '🔱',
  '🔲',
  '🔳',
  '🔴',
  '🔵',
  '🔶',
  '🔷',
  '🔸',
  '🔹',
  '🔺',
  '🔻',
  '🔼',
  '🔽',
  '🕋',
  '🕌',
  '🕍',
  '🕎',
  '🕐',
  '🕑',
  '🕒',
  '🕓',
  '🕔',
  '🕕',
  '🕖',
  '🕗',
  '🕘',
  '🕙',
  '🕚',
  '🕛',
  '🕜',
  '🕝',
  '🕞',
  '🕟',
  '🕠',
  '🕡',
  '🕢',
  '🕣',
  '🕤',
  '🕥',
  '🕦',
  '🕧',
  '🕺',
  '🖕',
  '🖖',
  '🖤',
  '🗻',
  '🗼',
  '🗽',
  '🗾',
  '🗿',
  '😀',
  '😁',
  '😂',
  '😃',
  '😄',
  '😅',
  '😆',
  '😇',
  '😈',
  '😉',
  '😊',
  '😋',
  '😌',
  '😍',
  '😎',
  '😏',
  '😐',
  '😑',
  '😒',
  '😓',
  '😔',
  '😕',
  '😖',
  '😗',
  '😘',
  '😙',
  '😚',
  '😛',
  '😜',
  '😝',
  '😞',
  '😟',
  '😠',
  '😡',
  '😢',
  '😣',
  '😤',
  '😥',
  '😦',
  '😧',
  '😨',
  '😩',
  '😪',
  '😫',
  '😬',
  '😭',
  '😮',
  '😯',
  '😰',
  '😱',
  '😲',
  '😳',
  '😴',
  '😵',
  '😶',
  '😷',
  '😸',
  '😹',
  '😺',
  '😻',
  '😼',
  '😽',
  '😾',
  '😿',
  '🙀',
  '🙁',
  '🙂',
  '🙃',
  '🙄',
  '🙅',
  '🙆',
  '🙇',
  '🙈',
  '🙉',
  '🙊',
  '🙋',
  '🙌',
  '🙍',
  '🙎',
  '🙏',
  '🚀',
  '🚁',
  '🚂',
  '🚃',
  '🚄',
  '🚅',
  '🚆',
  '🚇',
  '🚈',
  '🚉',
  '🚊',
  '🚋',
  '🚌',
  '🚍',
  '🚎',
  '🚏',
  '🚐',
  '🚑',
  '🚒',
  '🚓',
  '🚔',
  '🚕',
  '🚖',
  '🚗',
  '🚘',
  '🚙',
  '🚚',
  '🚛',
  '🚜',
  '🚝',
  '🚞',
  '🚟',
  '🚠',
  '🚡',
  '🚢',
  '🚣',
  '🚤',
  '🚥',
  '🚦',
  '🚧',
  '🚨',
  '🚩',
  '🚪',
  '🚫',
  '🚬',
  '🚭',
  '🚮',
  '🚯',
  '🚰',
  '🚱',
  '🚲',
  '🚳',
  '🚴',
  '🚵',
  '🚶',
  '🚷',
  '🚸',
  '🚹',
  '🚺',
  '🚻',
  '🚼',
  '🚽',
  '🚾',
  '🚿',
  '🛀',
  '🛁',
  '🛂',
  '🛃',
  '🛄',
  '🛅',
  '🤐',
  '🤑',
  '🤒',
  '🤓',
  '🤔',
  '🤕',
  '🤖',
  '🤗',
  '🤘',
  '🤙',
  '🤚',
  '🤛',
  '🤜',
  '🤝',
  '🤞',
  '🤟',
  '🤠',
  '🤡',
  '🤢',
  '🤣',
  '🤤',
  '🤥',
  '🤦',
  '🤧',
  '🤨',
  '🤩',
  '🤪',
  '🤫',
  '🤬',
  '🤭',
  '🤮',
  '🤯',
  '🤰',
  '🤱',
  '🤲',
  '🤳',
  '🤴',
  '🤵',
  '🤶',
  '🤷',
  '🤸',
  '🤹',
  '🤺',
  '🥀',
  '🥁',
  '🥂',
  '🥃',
  '🥄',
  '🥅',
  '🥇',
  '🥈',
  '🥉',
  '🥊',
  '🥋',
  '🥌',
  '🥐',
  '🥑',
  '🥒',
  '🥓',
  '🥔',
  '🥕',
  '🥖',
  '🥗',
  '🥘',
  '🥙',
  '🥚',
  '🥛',
  '🥜',
  '🥝',
  '🥞',
  '🥟',
  '🥠',
  '🥡',
  '🥢',
  '🥣',
  '🥤',
  '🥥',
  '🥦',
  '🥧',
  '🥨',
  '🥩',
  '🥪',
  '🥫',
  '🦀',
  '🦁',
  '🦂',
  '🦃',
  '🦄',
  '🦅',
  '🦆',
  '🦇',
  '🦈',
  '🦉',
  '🦊',
  '🦋',
  '🦌',
  '🦍',
  '🦎',
  '🦏',
  '🦐',
  '🦑',
  '🦒',
  '🦓',
  '🦔',
  '🦕',
  '🦖',
  '🦗',
  '🦘',
  '🦙',
  '🦚',
  '🦛',
  '🦜',
  '🦝',
  '🦞',
  '🦟',
  '🦠',
  '🦡',
  '🦢',
  '🦣',
  '🦤',
  '🦥',
  '🦦',
  '🦧',
  '🦨',
  '🦩',
  '🦪',
  '🦫',
  '🦬',
  '🦭',
  '🦮',
  '🦯',
  '🦰',
  '🦱',
  '🦲',
  '🦳',
  '🦴',
  '🦵',
  '🦶',
  '🦷',
  '🦸',
  '🦹',
  '🦺',
  '🦻',
  '🦼',
  '🦽',
  '🦾',
  '🦿',
  '🧀',
  '🧁',
  '🧂',
  '🧃',
  '🧄',
  '🧅',
  '🧆',
  '🧇',
  '🧈',
  '🧉',
  '🧊',
  '🧋',
  '🧌',
  '🧍',
  '🧎',
  '🧏',
  '🧐',
  '🧑',
  '🧒',
  '🧓',
  '🧔',
  '🧕',
  '🧖',
  '🧗',
  '🧘',
  '🧙',
  '🧚',
  '🧛',
  '🧜',
  '🧝',
  '🧞',
  '🧟',
  '🧠',
  '🧡',
  '🧢',
  '🧣',
  '🧤',
  '🧥',
  '🧦',
  '🧧',
  '🧨',
  '🧩',
  '🧪',
  '🧫',
  '🧬',
  '🧭',
  '🧮',
  '🧯',
  '🧰',
  '🧱',
  '🧲',
  '🧳',
  '🧴',
  '🧵',
  '🧶',
  '🧷',
  '🧸',
  '🧹',
  '🧺',
  '🧻',
  '🧼',
  '🧽',
  '🧾',
  '🧿',
  '🛐',
  '🛑',
  '🛒',
  '🛫',
  '🛬',
  '🛴',
  '🛵',
  '🛶',
  '🛷',
  '🛸',
  '🛹',
  '🛺',
  '🛻',
  '🛼',
  '🟠',
  '🟡',
  '🟢',
  '🟣',
  '🟤',
  '🟥',
  '🟦',
  '🟧',
  '🟨',
  '🟩',
  '🟪',
  '🟫',
  '🀄',
  '🃏',
  '🩰',
  '🩱',
  '🩲',
  '🩳',
  '🩴',
  '🩵',
  '🩶',
  '🩷',
  '🩸',
  '🩹',
  '🩺',
  '🩻',
  '🩼',
  '🪀',
  '🪁',
  '🪂',
  '🪃',
  '🪄',
  '🪅',
  '🪆',
  '🪇',
  '🪈',
  '🪉',
  '🪐',
  '🪑',
  '🪒',
  '🪓',
  '🪔',
  '🪕',
  '🪖',
  '🪗',
  '🪘',
  '🪙',
  '🪚',
  '🪛',
  '🪜',
  '🪝',
  '🪞',
  '🪟',
  '🪠',
  '🪡',
  '🪢',
  '🪣',
  '🪤',
  '🪥',
  '🪦',
  '🪧',
  '🪨',
  '🪰',
  '🪱',
  '🪲',
  '🪳',
  '🪴',
  '🪵',
  '🪶',
  '🪷',
  '🪸',
  '🪹',
  '🪺',
  '🪻',
  '🪼',
  '🪽',
  '🫀',
  '🫁',
  '🫂',
  '🫃',
  '🫄',
  '🫅',
  '🫐',
  '🫑',
  '🫒',
  '🫓',
  '🫔',
  '🫕',
  '🫖',
  '🫗',
  '🫘',
  '🫙',
  '🫚',
  '🫠',
  '🫡',
]
